import { useLayoutEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { capitalize } from '../../utils/utils';
import CollapsibleForm from '../CollapsibleForm.jsx';
import DishtypePreferences from '../DishtypePreferences';
import styles from './DishtypePreferencesSection.module.css';

const DishtypePreferencesSection = () => {
  const [dishtypePrefsText, setDishtypePrefsText] = useState('');
  const [dishPreferenceFormVisible, setDishPreferenceFormVisible] =
    useState(false);
  const [initialPrefs, setInitialPrefs] = useState(null);
  const [currentPrefs, setCurrentPrefs] = useState([]);

  const ref = useRef();
  const { hash } = useLocation();
  const deepLink = 'recipe-preferences';
  const isDeepLinked = hash.includes(deepLink);

  const currentPrefsMatchInitial =
    currentPrefs.length === initialPrefs?.length &&
    currentPrefs.every((pref) => initialPrefs.includes(pref));

  const createDisplayedText = (prefs, options) => {
    const text = prefs
      .map((pref) => capitalize(options[pref]['optionText']))
      .join(', ');
    setDishtypePrefsText(text);
  };

  const handleOnChange = (prefs, options) => {
    createDisplayedText(prefs, options);

    if (initialPrefs === null) setInitialPrefs(prefs);
    setCurrentPrefs(prefs);
  };

  useLayoutEffect(() => {
    if (isDeepLinked) {
      setDishPreferenceFormVisible(true);
      ref.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }
  }, [isDeepLinked]);

  return (
    <div
      className={`hr-mb-32 ${styles.container}`}
      data-testid="dishtype-preferences"
      ref={ref}
    >
      <CollapsibleForm
        title="Recipe Preferences"
        text={dishtypePrefsText || 'Set your preferences.'}
        iconDesktop={`/public/img/preferences/dishtype_icon.svg`}
        contentVisible={dishPreferenceFormVisible}
        toggleForm={() =>
          setDishPreferenceFormVisible(!dishPreferenceFormVisible)
        }
        dataCy={'dish-type-preferences'}
      >
        <div className="dishtype-preferences">
          <div className="hr-mb-16_fixed hr-center-txt">
            Tell us what you like best and we’ll send you those kinds of recipes
            more often.
          </div>
          <div className="hr-mb-16_fixed">
            <DishtypePreferences onChange={handleOnChange} />
          </div>
          <button
            data-testid="dishtype-preferences-update-button"
            className="hr-btn-blue"
            onClick={() => {
              setDishPreferenceFormVisible(false);
              setInitialPrefs(currentPrefs);
            }}
            disabled={currentPrefsMatchInitial}
          >
            Update
          </button>
        </div>
      </CollapsibleForm>
    </div>
  );
};

export default DishtypePreferencesSection;
